import React from 'react';
import { Text } from '@kl/components-v6';
import { TextProps } from '@kl/components-v6/src/typography/text/types';
import { Locale, LocaleProps } from 'shared/ui/locale';

export interface LocaleTextProps extends TextProps, Pick<LocaleProps, 'params'> {
    localizationKey: string;
}

export const LocalizedText: React.FC<LocaleTextProps> = ({
    params = [],
    localizationKey,
    ...textProps
}) => {
    const { type = 'BTM3', ...restTextProps } = textProps;

    return (
        <Text type={type} {...restTextProps}>
            <Locale localizationKey={localizationKey} params={params} />
        </Text>
    );
};
